import axios from "axios";

// Empty/unset means same-origin — that's the docker build, where nginx proxies
// /api to the backend container.
const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API_URL = `${BASE}/api`;

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ros_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("ros_token");
      localStorage.removeItem("ros_user");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default api;
